module.exports = __webpack_public_path__ + "static/media/sipgate_white.f94f22cb.svg";